import {QueryParamsEnum, RequestSchedule} from 'presentation/constants';
import {BookingDataState} from 'presentation/modules/booking/shared/store/useBookingStore/types';

import {NavigateFunction} from 'react-router-dom';

const goToRequestSchedule = ({
	bookingData,
	requestCity,
	navigate,
}: {
	bookingData: BookingDataState;
	requestCity: string;
	navigate: NavigateFunction;
}) => {
	const searchParams = new URLSearchParams();
	searchParams.set(QueryParamsEnum.UF_NAME, bookingData.ufName);
	searchParams.set(QueryParamsEnum.UF_CODE, bookingData.ufCode);
	searchParams.set(QueryParamsEnum.CITY_NAME, bookingData.cityName);
	searchParams.set(QueryParamsEnum.SPECIALTY_NAME, bookingData.specialtyName);
	searchParams.set(QueryParamsEnum.SPECIALTY_CODE, bookingData.specialtyCode);
	searchParams.set(QueryParamsEnum.SUB_SPECIALTY_CODE, bookingData?.subSpecialtyCode ?? '');
	searchParams.set(QueryParamsEnum.REQUEST_SCHEDULE_PERMISSION_CITY, requestCity);

	navigate(`${RequestSchedule.REQUEST}?${searchParams.toString()}`);
};

export {goToRequestSchedule};
